module.exports = __webpack_public_path__ + "static/media/inter.564035e4.jpg";